import { Button } from '@veneer/core';
import React from 'react';
import { Container } from './styles';
import { useTranslationHelper } from 'src/contexts/dependencyManager/utils';

export default function ErrorCard(): JSX.Element {
  const getText = useTranslationHelper();
  const reloadPage = () => {
    window.location.reload();
  };

  return (
    <Container data-testid="error-card">
      <p className="title">
        {getText('errorScreen.title', 'Something went wrong')}
      </p>
      <p className="subtitle">
        {getText(
          'errorScreen.subtitle',
          'Your upgrade options couldn’t be loaded.'
        )}
      </p>
      <Button
        className="reload-button"
        appearance="secondary"
        onClick={reloadPage}
        data-testid="reload-button"
      >
        {getText('errorScreen.reloadButton', 'Refresh the page')}
      </Button>
    </Container>
  );
}
